import { Box, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';

export interface DateEditCellProps {
    onChange: (value: string) => void;
    field: string;
    value?: string;
}

export const DateEditCell = ({ onChange, field, value, hideLabel }: DateEditCellProps & { hideLabel?: boolean }) => {
    const [dateValue, setDateValue] = useState<Dayjs | null>(value && dayjs(value).isValid() ? dayjs(value).startOf('day') : null);

    useEffect(() => {
        value && dayjs(value).isValid() && setDateValue(dayjs(value).startOf('day'));
    }, [value]);

    const handleChange = async (newValue: Dayjs | null) => {
        if (!newValue) {
            setDateValue(null);
            onChange('');
        } else {
            const date = dayjs(newValue);
            const isValidDate = date.isValid();
            if (isValidDate) {
                const formattedValue = date.toISOString();
                setDateValue(date);
                onChange(formattedValue);
            }
        }
    };

    return (
        <Box sx={{ minWidth: 149 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
                <DatePicker
                    label={!hideLabel && field}
                    value={dateValue}
                    inputFormat="MM/DD/YYYY"
                    onChange={handleChange}
                    renderInput={(params) => <TextField {...params} />}
                />
            </LocalizationProvider>
        </Box>
    );
};
